import { Component, OnInit } from '@angular/core';
import { SC_Input } from "../../../../common/input/SC_Input";
import { SC_RoofHook } from "../../../../common/stocklist/roofhook/SC_RoofHook";
import { RoofHookInput } from "../../../../common/stocklist/roofhook/RoofHookInput";
import { TranslateService } from "../../../../common/variables/translate-service";
import { forkJoin } from 'rxjs';
import { GlobalVariableService } from "../../../../common/variables/global-variable";
import { GlobalService } from "../../../../common/services/global.service";
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'sen-app-roof-hook',
  templateUrl: './roof-hook.component.html',
  styleUrls: ['./roof-hook.component.scss']
})
export class RoofHookComponent implements OnInit {
  rbBasePlate: number;
  rbBasePlateBig: number = SC_RoofHook.BASE_PLATE_BIG;
  rbBasePlateMixed: number = SC_RoofHook.BASE_PLATE_MIXED;
  rbBasePlateSmall: number = SC_RoofHook.BASE_PLATE_SMALL;
  rbTypeVario: number;
  rbTypeVarioDuo: number = SC_RoofHook.TYPE_VARIO_DUO;
  rbTypeVarioSolo: number = SC_RoofHook.TYPE_VARIO_SOLO;

  varioItemDescriptionSolo: any;
  varioItemDescriptionDuo: any;
  plateItemDescriptionBig: any;
  plateItemDescriptionSmall: any;

  constructor(public translate: TranslateService,
    public global: GlobalVariableService,
    public globalService: GlobalService) {
    SC_Input.roofhookinputCurrent.sVarBasePlateBig = "RH_BASE_L";
    SC_Input.roofhookinputCurrent.sVarBasePlateSmall = "RH_BASE_S";
    SC_Input.roofhookinputCurrent.sVarSuppShaftVarioDuo = "RH_SUPSHAFT_ADJ";
    SC_Input.roofhookinputCurrent.sVarSuppShaftVarioSolo = "RH_SUPSHAFT";
  }

  ngOnInit(): void {
    this.fetchInput();
  }

  private fetchInput() {

    if (!SC_Input.roofhookinputCurrent.iBasePlate || !SC_Input.roofhookinputCurrent.iType) {
      SC_Input.roofhookinputCurrent = new RoofHookInput();
      SC_Input.roofhookinputCurrent.iBasePlate = SC_RoofHook.BASE_PLATE_MIXED;
      SC_Input.roofhookinputCurrent.iType = SC_RoofHook.TYPE_VARIO_SOLO;
    }
    this.rbBasePlate = SC_Input.roofhookinputCurrent.iBasePlate;
    this.rbTypeVario = SC_Input.roofhookinputCurrent.iType;
    this.setRoofHookVars();
    //no small base plate
    //TODO: remove small base plate option
    // rbBasePlateSmall.selected = false;
    // rbBasePlateSmall.enabled = false;
  }

  private setRoofHookVars(): void {
    SC_Input.roofhookinputCurrent.sVarBasePlateBig = "RH_BASE_L";
    SC_Input.roofhookinputCurrent.sVarBasePlateSmall = "RH_BASE_S";
    SC_Input.roofhookinputCurrent.sVarSuppShaftVarioDuo = "RH_SUPSHAFT_ADJ";
    SC_Input.roofhookinputCurrent.sVarSuppShaftVarioSolo = "RH_SUPSHAFT";
  }

  ngOnDestroy() {
    if (SC_Input.roofhookinputCurrent.iBasePlate != this.rbBasePlate || SC_Input.roofhookinputCurrent.iType != this.rbTypeVario) {
      SC_Input.isPlanAltered = true;
    }
    SC_Input.roofhookinputCurrent.iBasePlate = this.rbBasePlate;
    SC_Input.roofhookinputCurrent.iType = this.rbTypeVario;
  }

  getVarioItemDesc(popOver: NgbPopover) {
    forkJoin([
      this.globalService.getData({ cmd: this.global.ItemDescription, itemCode: SC_Input.roofhookinputCurrent.sVarSuppShaftVarioSolo }),
      this.globalService.getData({ cmd: this.global.ItemDescription, itemCode: SC_Input.roofhookinputCurrent.sVarSuppShaftVarioDuo })
    ]).subscribe(([vSolo, vDuo]) => {
      this.varioItemDescriptionSolo = vSolo;
      this.varioItemDescriptionDuo = vDuo;
      popOver.open();
    });
  }

  getShaftItemDesc(popOver: NgbPopover) {
    forkJoin([
      this.globalService.getData({ cmd: this.global.ItemDescription, itemCode: SC_Input.roofhookinputCurrent.sVarBasePlateBig }),
      this.globalService.getData({ cmd: this.global.ItemDescription, itemCode: SC_Input.roofhookinputCurrent.sVarBasePlateSmall })
    ]).subscribe(([big, small]) => {
      this.plateItemDescriptionBig = big;
      this.plateItemDescriptionSmall = small;
      popOver.open();
    });
  }

}
